import { AnalyticsContextValue } from "@swiggy-private/analytics/dist/contexts";
import { SCREEN_NAME } from "./init";

let lastScreen = "";
export const setLastScreen = (curLastScreen?: string) => {
    lastScreen = curLastScreen || "";
    return lastScreen;
};

// Home Page Events
export const impressionHomeMastHead = (impressionEvent: AnalyticsContextValue["impressionEvent"]) => {
    impressionEvent({
        category: SCREEN_NAME.HOME_PAGE,
        action: "impression-coupon-masthead",
        lastScreen,
    });
};

export const impressionCouponCodeInput = (impressionEvent: AnalyticsContextValue["impressionEvent"]) => {
    impressionEvent({
        category: SCREEN_NAME.HOME_PAGE,
        action: "impression-coupon-code-input",
        lastScreen,
    });
};

export const clickCouponCodeInput = (clickEvent: AnalyticsContextValue["clickEvent"], label: string) => {
    clickEvent({
        category: SCREEN_NAME.HOME_PAGE,
        action: "click-coupon-code-input",
        label,
        lastScreen,
    });
};

export const clickApplyButtonEvent = (clickEvent: AnalyticsContextValue["clickEvent"], label: string) => {
    clickEvent({
        category: SCREEN_NAME.HOME_PAGE,
        action: "click-apply-coupon",
        context: "APPLY COUPON",
        label: JSON.stringify(label),
        lastScreen,
    });
};

export const impressionFaqButtonEvent = (impressionEvent: AnalyticsContextValue["impressionEvent"]) => {
    impressionEvent({
        category: SCREEN_NAME.HOME_PAGE,
        action: "impression-faq-coupon",
        lastScreen,
    });
};

export const impressionTncButtonEvent = (impressionEvent: AnalyticsContextValue["impressionEvent"]) => {
    impressionEvent({
        category: SCREEN_NAME.HOME_PAGE,
        action: "impression-tnc-coupon",
        lastScreen,
    });
};

export const clickFaqButtonEvent = (clickEvent: AnalyticsContextValue["clickEvent"]) => {
    clickEvent({
        category: SCREEN_NAME.HOME_PAGE,
        action: "click-faq-coupon",
        lastScreen,
    });
};

export const clickTncButtonEvent = (clickEvent: AnalyticsContextValue["clickEvent"]) => {
    clickEvent({
        category: SCREEN_NAME.HOME_PAGE,
        action: "click-tnc-coupon",
        lastScreen,
    });
};

export const impressionApplyingCouponLoaderEvent = (impressionEvent: AnalyticsContextValue["impressionEvent"]) => {
    impressionEvent({
        category: SCREEN_NAME.HOME_PAGE,
        action: "impression-applying-coupon",
        lastScreen,
    });
};

export const impressionSwiggyOneNotAvailableEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    label: string,
) => {
    impressionEvent({
        category: SCREEN_NAME.HOME_PAGE_UNAVAILABLE,
        action: "impression-one-unavailable",
        label: label,
        lastScreen,
    });
};

// Cart Page Events
export const impressionCouponAppliedModalEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    label?: string,
) => {
    impressionEvent({
        category: SCREEN_NAME.CART_PAGE,
        action: "impression-coupon-success",
        lastScreen,
        label,
    });
};

export const clickCouponAppliedModalSuccess = (clickEvent: AnalyticsContextValue["clickEvent"], label?: string) => {
    clickEvent({
        category: SCREEN_NAME.CART_PAGE,
        action: "click-coupon-success",
        lastScreen,
        label,
    });
};

export const impressionImageCardEvent = (impressionEvent: AnalyticsContextValue["impressionEvent"], label: string) => {
    impressionEvent({
        category: SCREEN_NAME.CART_PAGE,
        action: "impression-image-card",
        label: label,
        lastScreen,
    });
};

export const impressionPlanBenefitsDetails = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    label: string,
) => {
    impressionEvent({
        category: SCREEN_NAME.CART_PAGE,
        action: "impression-plan-redeemed",
        label: label,
        lastScreen,
    });
};

export const impressionCouponAppliedContainerEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    label: string,
) => {
    impressionEvent({
        category: SCREEN_NAME.CART_PAGE,
        action: "impression-coupon-code-applied",
        label: label,
        lastScreen,
    });
};

export const impressionRemoveButtonEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    label: string,
) => {
    impressionEvent({
        category: SCREEN_NAME.CART_PAGE,
        action: "impression-coupon-code-remove",
        lastScreen,
        label,
    });
};

export const clickRemoveButtonEvent = (clickEvent: AnalyticsContextValue["clickEvent"], label: string) => {
    clickEvent({
        category: SCREEN_NAME.CART_PAGE,
        action: "click-coupon-code-remove",
        lastScreen,
        label,
    });
};

export const impressionPurchaseButtonEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    label: string,
) => {
    impressionEvent({
        category: SCREEN_NAME.CART_PAGE,
        action: "impression-activate-membership",
        lastScreen,
        label,
    });
};

export const clickPurchaseButtonEvent = (clickEvent: AnalyticsContextValue["clickEvent"], label: string) => {
    clickEvent({
        category: SCREEN_NAME.CART_PAGE,
        action: "click-activate-membership",
        lastScreen,
        label,
    });
};
